import css from 'styled-jsx/css';
import { productPriceItemTypes } from './enums';

export default css`
    .product-price--${productPriceItemTypes.detailRecurringPrice}{
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        align-items: center;
    }
    .product-price-promoted--${productPriceItemTypes.detailRecurringPrice}{
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        align-items: center;
    }
    .product-price--${productPriceItemTypes.detailOneTimePrice}{
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        align-items: center;
    }
    .product-price-promoted--${productPriceItemTypes.detailOneTimePrice}{
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        align-items: center;
    }
    .product-price--${productPriceItemTypes.summaryRecurringPrice}{
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        align-items: center;
    }
    .product-price-promoted--${productPriceItemTypes.summaryRecurringPrice}{
        margin-top: 8px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        :global(.text--space::after){
            display: inline-block;
            content: " ";
        }
    }
    .product-price--${productPriceItemTypes.summaryOneTimePrice}{
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        align-items: center;
    }
    .product-price-promoted--${productPriceItemTypes.summaryOneTimePrice}{
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        align-items: center;
    }
    .product-price--${productPriceItemTypes.summaryTradeInPrice}{
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        align-items: center;
    }
    .product-price-info--${productPriceItemTypes.summaryTradeInPrice}{
        margin-top: 8px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        :global(.text--space::after){
            display: inline-block;
            content: " ";
        }
    }
    .product-price--${productPriceItemTypes.detailRecurringPriceCoverageModal}{
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        align-items: center;
    }
    .product-price-promoted--${productPriceItemTypes.detailRecurringPriceCoverageModal}{
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        align-items: center
    }
    .product-price--${productPriceItemTypes.detailOneTimePriceCoverageModal}{
        display: flex;
        justify-content: flex-start;
        flex-direction: row;
        align-items: center;
        :global(.text--space::after){
            display: inline-block;
            content: ":\00a0";
        }
    }
    .product-price-promoted--${productPriceItemTypes.detailOneTimePriceCoverageModal}{
        display: flex;
        justify-content: flex-start;
        flex-direction: row;
        align-items: center;
        :global(.text--space::after){
            display: inline-block;
            content: ":\00a0";
        }
    }
    :global(.product-price__description){
        margin-top: 8px;
    } 
    :global(.max-price__text:after) {
        content: ' ';
        white-space: pre;
    }

`;
